var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":{path: _vm.path, params: _vm.row},"target":"_blank"}},[_vm._v("\n  "+_vm._s(_vm.name)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }